import React from "react";
import { Field } from "redux-form";

const CustomInput = field => {
  if (field.isReadOnly) {
    if (field.fullDisplay) {
      return (
        <div>
          <input
            {...field.input}
            type={field.type || "text"}
            min={field.min}
            max={field.max}
            style={field.style}
            readOnly={true}
          />
        </div>
      );
    } else {
      return (
        <div>
          {field.input.value} {field.postfix}
        </div>
      );
    }
  }

  if (field.format && field.input.value) {
    field.input.value = field.format(field.input.value);
  }

  return (
    <div>
      <input
        {...field.input}
        type={field.type || "text"}
        min={field.min}
        max={field.max}
        style={field.style}
      />{" "}
      <span>{field.postfix}</span>
      {field.meta.touched && field.meta.error && (
        <div style={{ color: "red" }}>{field.meta.error}</div>
      )}
    </div>
  );
};

const InputField = props => <Field {...props} component={CustomInput} />;

export default InputField;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/FormField/InputField.js